import {
  SessionsDataTableDocument,
  TrainingSessionsDataTableDocument,
} from 'generated/resources/datatable.graphql'
import {
  DestroySessionDocument,
  DestroySessionMutation,
  DestroySessionMutationVariables,
  TrainingClassesDocument,
  TrainingDetailPageDocument,
  TrainingSessionsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDestroySession = () => {
  const [destroySession, { loading }] = useMutation(DestroySessionDocument, {
    extractorFn: (data: DestroySessionMutation) => data.trainingsMutations.deleteTrainingsSession,
  })

  return {
    loading,
    destroySession(variables: DestroySessionMutationVariables) {
      return destroySession({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          SessionsDataTableDocument,
          TrainingClassesDocument,
          TrainingSessionsDataTableDocument,
          TrainingDetailPageDocument,
          TrainingSessionsDocument,
        ],
      })
    },
  }
}
